import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { useFormProps } from "./page-props"
import { PageBody } from "@/components/ui/layout"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { formSchema } from "./form-schema"
import { useId } from "react"
import { SaveButton } from "@/components/shared/action-buttons"
import { learnersStudent } from "@/routes"
import { useNavigate, usePathParam } from "@/lib/page-rendering"

// The student's own profile form, in their workspace. A school admin edits
// the same form through learners/school_students/edit.
export default function Page() {
  const id = useId()
  const studentId = usePathParam("id")

  return (
    <>
      <LearnerPageChrome action={<SaveButton form={id} />} />
      <StudentProfileForm
        formId={id}
        action={learnersStudent({ id: studentId }).url}
      />
    </>
  )
}

// The profile form's body, which submits to `action`.
export function StudentProfileForm({
  formId,
  action,
}: {
  formId: string
  action: string
}) {
  const { student, student_attachments } = useFormProps()
  const navigate = useNavigate()

  const handleSubmit = (data: any) => {
    navigate({
      href: action,
      method: "patch",
      data: {
        student_json: JSON.stringify(data.student),
        student_attachments: data.student_attachments,
      },
      formData: true,
    })
  }

  return (
    <PageBody>
      <FormRenderer
        schema={formSchema}
        formId={formId}
        onSubmit={handleSubmit}
        defaultValues={{ student, student_attachments }}
      />
    </PageBody>
  )
}
